import { useState } from 'react'
import Navbar from '../../../../components/Navbar'
// import './index.css'

type Ipros = {
    toggle: (value: boolean) => void
}

const Header = ({ toggle }: Ipros) => {
    const [collapsed, setCollapsed] = useState(false)

    const toggleNavbar = () => {
        setCollapsed(!collapsed)
    }
    return (
        <>
            <button
                onClick={() => {
                    toggle(!collapsed)
                    toggleNavbar()
                }}
                className={`menu-icon`}
            >
                ☰
            </button>
            {/* <header className="navbar sticky-top  flex-md-nowrap p-0 "> */}
            <div className="navbar-nav navbar-nav-custom-item">
                <div className="nav-item text-nowrap">
                    <Navbar />
                </div>
            </div>
            {/* </header> */}
        </>
    )
}
export default Header
